/**
 * Node ID format and global variable prefix for pipeline compute nodes.
 */

export const GLOBAL_VAR_PREFIX = 'global:var:';

export const NODE_ID = {
  property: (elementId: string, propertyName: string) =>
    `${elementId}:prop:${propertyName}`,
  productCount: (elementId: string) => `${elementId}:count`,
  results: (elementId: string) => `${elementId}:results`,
} as const;
